import request from './request';
export function createLottery(data) {
  return request.post('/api/lottery/create', data);
}
export function joinLottery(lotteryId) {
  return request.post('/api/lottery/join', { lottery_id: lotteryId });
}
export function drawLottery(lotteryId) {
  return request.post('/api/lottery/draw', { lottery_id: lotteryId });
}
export function getCurrentLottery(roomId) {
  return request.get('/api/lottery/currentLottery', { params: { room_id: roomId } });
}
export function getLotteryHistory(params) {
  return request.get('/api/lottery/history', { params });
}
